import styled, { css } from 'styled-components';

const LayoutZ = styled.div(
  ({ theme }) => css`
    display: flex;
    background-color: ${theme.colors.gray200};
    margin: 0;
  `
);

const NewTable = styled.div(
  ({ theme }) => css`
    background-color: ${theme.colors.gray200};
    width: 100%;
    justify-content: space-between;
    // Here Change format to Table
    ${theme.breakpoint('md')} {
      display: flex 0 0 auto;
      flex-direction: column;
      background-color: ${theme.colors['gray200']};
    }
  `
);

const RowZ = styled.div(
  ({ theme }) => css`
    display: ${(props) => (props.header ? 'none' : 'flex')};
    flex-wrap: wrap;
    opacity: 1;
    border-radius: 6px;
    background-color: #fff;
    padding: 16px 24px 8px;
    margin-bottom: 8px;
    justify-content: space-between;
    // Here Change format to Table
    ${theme.breakpoint('md')} {
      display: flex;
      flex-direction: row;
      background-color: ${(props) => (props.header ? `${theme.colors.gray200}` : '#ffffff')};
      border-radius: 6px;
      padding: 0 11px;
      height: 48px;
      justify-content: space-between;
      flex-wrap: wrap;
      align-content: center;
      margin-bottom: ${(props) => (props.header ? '0px' : '8px')};
    }
    ${theme.breakpoint('ll')} {
      padding: ${(props) => (props.header ? '0 19px' : '0 19px')};
      margin-bottom: ${(props) => (props.header ? '0px' : '8px')};
    }
  `
);

const ColZ = styled.div(
  ({ theme }) => css`
    display: ${(props) => (props.nodata ? 'none' : 'block')};
    width: 50%;
    margin-bottom: 8px;
    text-align: ${(props) => props.textalign || 'left'};
    order: 0;
    // Here Change format to Table
    ${theme.breakpoint('md')} {
      display: block;
      padding-top: 3px;
      height: 20px;
      margin-bottom: 0px;
      width: auto;
      margin-right: 10px;
      flex: ${(props) => (props.flex ? '2' : '1')};
      text-align: ${(props) => props.align || 'left'};
      order: ${(props) => props.order || '0'};
    }
  `
);

export { NewTable };
export { RowZ, ColZ, LayoutZ };
